// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__v9mA+","showModal":"Modal_showModal__IS9u+","outer":"Modal_outer__B4TkJ","close":"Modal_close__nt4fk","title":"Modal_title__ybgF3"};